import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 18 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 4\" id=\"more\"><path d=\"M14 2a2 2 0 1 0 4.001-.001A2 2 0 0 0 14 2m-3 0a2 2 0 1 0-4.001.001A2 2 0 0 0 11 2M4 2a2 2 0 1 0-4.001.001A2 2 0 0 0 4 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol